export function createPersistableDemoConfig(config = {}, demoConfig = {}, defaultConfig = {}, paths = []) {
	const saved = JSON.parse(JSON.stringify(config))
	for (const path of paths) {
		const keys = String(path).split(".").filter(Boolean)
		let current = saved
		let original = demoConfig
		let fallback = defaultConfig
		for (const key of keys.slice(0, -1)) {
			current = current?.[key]
			original = original?.[key]
			fallback = fallback?.[key]
		}
		const last = keys.at(-1)
		if (last && current && current[last] === original?.[last]) current[last] = fallback?.[last]
	}
	return saved
}
